
/***************************************************************
 * Extended Klaro Consent Config
 *
 * extended:
 * 		- Trigger / Notice, click Funcs
 * 		- iFrame Fallback with klaro-activation
 * 		- Logging Callback Function -> cmlogger.php
 *
 * By feedback werbeagentur GmbH
 * [v 1.1.0 : fullScreen, fixes, coldfusion logger]
 * v 1.2.0 : removed jQuery functions, modular split: klaro.extended.js, extra classes, iframe-settings
 * 2020-07
 ***************************************************************/

 var klaroConfig = {
 	privacyPolicy: '/datenschutz', // URL: Datenschutzrichtlinien
 	fullScreen : false, // extended // fullscreen cookie notice overlay
 	noticetype : 'trigger', // extended // 'trigger' or 'notice'
 	cmloggerurl : '/consent/cmlogger.php', // extended //url of cmlogger file
	iframe: { // extended // iframe-settings
		enable: true, //enable/disable extended blocker + fallbacks of iframes
		texts: {
			de: {
				title: 'Dies ist ein externer Inhalt von ',
				desc: 'Wenn Sie die Inhalte sehen möchten geben Sie bitte Ihre Zustimmung und klicken Sie auf den Button.',
				btn: 'Externen Inhalt anzeigen'
			},
			en: {
				title: 'This is an external content provided by ',
				desc: 'If you would like to see the content please give your consent and click on the button.',
				btn: 'Show external content'
			},
		},
		styles: { //css values
			font: '"Ubuntu", "Neue Helvetica", Helvetica, sans-serif',
			blur: '10px', // 10px
			borderradius: '0px', // 5px
			border: '0',
			boxshadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
			headercolor: '#1E3D8E',
			headertxcolor: '#ffffff',
			btncolor: '#1E3D8E',
			btntxcolor: '#ffffff',
			bgcolor: '#ffffff',
			tx: '#333333',
			showIcon: true, // button checkmark icon
		}
	},

	// TEXTS
	translations: {
        de: {
            googleanalytics: {
                description: 'Dienst zur Sammlung von Besucherstatistiken betrieben von Google Ireland. Einbindung über Google Tag Manager. Daten können auch in unsichere Drittländer[USA] Hier finden Sie die Datenschutzrichtlinien des Betreibers: https://policies.google.com/privacy.',
            },
            matomo: {
                description: 'Dienst zur Sammlung von Besucherstatistiken für die Optimierung dieser Seite. Die Daten werden nicht an dritte veräußert und dienen nur der statistischen Auswertung.',
            },
            youtube: {
                description: 'Youtube ist ein Videoportal und ermöglicht die Einbindung von Videos auf dieser Internetseite. Dabei können Daten an Google und auch an ein unsicheres Drittland [USA] übertragen werden. Youtube-Datenschutzrichtlinien: https://support.google.com/youtube/answer/7671399?p=privacy_guidelines&hl=de',
            },
            degree23map: {
                description: '23degrees.io stellt Daten in anschaulichen Grafiken dar und bietet diese zur Einbettung auf dieser Internetseite an. Dabei können Daten an 23degrees.io übertragen werden, darauf haben wir keinen Einfluss.',
            },
            vimeo: {
                description: 'Vimeo ist ein Videoportal und ermöglicht die Einbindung von Videos auf dieser Internetseite. Dabei können Daten an Vimeo übertragen werden.',
            },
            webcams: {
                description: 'Wir binden Webcams von foto-webcam.eu ein. Dabei können Daten an foto-webcam.eu übertragen und verarbeitet werden. Darauf haben wir keinen Einfluss.',
            },
            lincolnwebcams: {
                description: 'Wir binden Webcams von webcam-profi.de ein. Dabei können Daten an webcam-profi.de übertragen und verarbeitet werden. Darauf haben wir keinen Einfluss.',
            },
            darmstadtshop: {
                description: 'Einbindung eines Darmstadt-Shops über toubiz.de. Dabei können Daten an toubiz.de übertragen und verarbeitet werden. Darauf haben wir keinen Einfluss.',
            },
            connfair: {
                description: 'Ticketbuchung über connfair für den Runden Tisch für Vereine. Hier werden Daten an connfair übertragen und verarbeitet.',
            },
            klaro: {
                description: 'Tool zur Verwaltung und Protokollierung der Datenerfassungszustimmung. Keine externe Verbindung oder Speicherung von Daten. Cookie wird gesetzt, um die Privatsphäre-Einstellungen der Benutzer zu speichern.'
            },
            purposes: {
                analytics: 'Besucher-Statistiken',
                video: 'Multimedia',
                iframe: 'iFrame Einbindung'
            },
        },
        en: {
            googleanalytics: {
                description: "Service for collecting visitor statistics operated by Google Ireland. Implemented via Google Tag Manager. You can find the operator's privacy policy here: https://policies.google.com/privacy.",
            },
            matomo: {
                description: 'Service for collecting visitor statistics',
            },
             youtube: {
                description: 'show YouTube video',
            },
            degree23map: {
                description: 'show 23° map',
            },
            vimeo: {
                description: 'show Vimeo video',
            },
            klaro: {
                description: 'Data-Collection Consent Management tool. No external storing of data. Cookie will be set to save privacy user settings.'
            },
            purposes: {
                analytics: 'Analytics',
                video: 'Multimedia',
                iframe: 'iFrame integration'
            },
        }
    },

    // APPS
    apps: [
        {
            name: 'youtube',
            title: 'YouTube',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);
            },
            purposes: ['video'],
        },
        // {
        //     name: 'vimeo',
        //     title: 'Vimeo',
        //     callback: function(consent, app) {
        //         klaroConsentLogging.send(app.name, consent);
        //     },
        //     purposes: ['video'],
        // },
        {
            name: 'matomo',
            title: 'Matomo',
            purposes: ['analytics'],
            cookies: [
                [/^_pk_.*$/, '/', 'klaro.kiprotect.com'], //for the production version
                [/^_pk_.*$/, '/', 'localhost'], //for the local version
                'piwik_ignore',
            ],
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);
            },
            required: false,
            optOut: false,
            default: false, //nach BGH Urteil/DSGVO darf nicht true sein... Stand.: 07.2020
            onlyOnce: true,
        },
        {
            name: 'degree23map',
            title: '23degrees.io',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);
            },
            purposes: ['iframe'],
        },
        {
            name: 'webcams',
            title: 'foto-webcam.eu',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);                  
            },
            purposes: ['video'],
        },
        {
            name: 'connfair',
            title: 'Connfair Ticketbuchung',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);                  
            },
            purposes: ['iframe'],
        },
        {
            name: 'lincolnwebcams',
            title: 'webcam-profi.de',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);

                //RS Mathis 
                if(consent){
                    $('.load-consent.lincoln-webcams').each(function(){                        
                        $that = $(this);
                        datasrc = $that.attr('data-src');
                        $that.find('a.fancybox').attr('href',datasrc);
                        $that.find('img').attr('src',datasrc);
                        $that.find('.ki--wrapper, .ki--bg').remove();
                    })
                }
            },
            purposes: ['video'],
        },
        {
            name: 'darmstadtshop',
            title: 'Darmstadt Shop / toubiz.de',
            callback: function(consent, app) {
                klaroConsentLogging.send(app.name, consent);
            },
            purposes: ['iframe'],
        },
    ],
};
